export default __webpack_public_path__ + "static/media/reactjs-logo.cfbc1fb0.svg";